import { Inject } from '@angular/core';
import '@angular/compiler';
import { PageContactComponent } from './page.contact/page.contact.component';
import { PortalSeasonLoadingDefaultComponent } from './portal.season.loading.default/portal.season.loading.default.component';
import { PortalPostDetailComponent } from './portal.post.detail/portal.post.detail.component';
import { PortalPostListComponent } from './portal.post.list/portal.post.list.component';
import { PageNewsComponent } from './page.news/page.news.component';
import { LayoutSeasonComponent } from './layout.season/layout.season.component';
import { PortalSeasonLoadingSeasonComponent } from './portal.season.loading.season/portal.season.loading.season.component';
import { PageMypageComponent } from './page.mypage/page.mypage.component';
import { PageMainComponent } from './page.main/page.main.component';
import { LayoutEmptyComponent } from './layout.empty/layout.empty.component';
import { PageAccessComponent } from './page.access/page.access.component';
import { ComponentNavigationComponent } from './component.navigation/component.navigation.component';
import { PortalSeasonPaginationComponent } from './portal.season.pagination/portal.season.pagination.component';
import { PageCareerComponent } from './page.career/page.career.component';
import { PageDashboardComponent } from './page.dashboard/page.dashboard.component';
import { PageResearchComponent } from './page.research/page.research.component';
import { ComponentChatbotComponent } from './component.chatbot/component.chatbot.component';
import { PagePostsItemComponent } from './page.posts.item/page.posts.item.component';
import { PortalSeasonTreeComponent } from './portal.season.tree/portal.season.tree.component';
import { PortalSeasonFormDropdownComponent } from './portal.season.form.dropdown/portal.season.form.dropdown.component';
import { PageAboutComponent } from './page.about/page.about.component';
import { ComponentFooterComponent } from './component.footer/component.footer.component';
import { PagePostsComponent } from './page.posts/page.posts.component';
import { PageSolutionsComponent } from './page.solutions/page.solutions.component';
import { PageMembersComponent } from './page.members/page.members.component';
import { LayoutSidebarComponent } from './layout.sidebar/layout.sidebar.component';
import { ComponentNavSidebarComponent } from './component.nav.sidebar/component.nav.sidebar.component';
import { ComponentTypingComponent } from './component.typing/component.typing.component';
import { PortalSeasonModalComponent } from './portal.season.modal/portal.season.modal.component';
import { PageNewsItemComponent } from './page.news.item/page.news.item.component';
import { PageAdminComponent } from './page.admin/page.admin.component';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, COMPOSITION_BUFFER_MODE } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NuMonacoEditorModule } from '@ng-util/monaco-editor';
import { SortablejsModule } from "src/libs/portal/season/ngx-sortablejs";
import { KeyboardShortcutsModule } from 'ng-keyboard-shortcuts';
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({ name: 'safe' })
export class SafePipe implements PipeTransform {
    constructor(@Inject( DomSanitizer) private domSanitizer: DomSanitizer) { }
    transform(url) {
        return this.domSanitizer.bypassSecurityTrustResourceUrl(url);
    }
}

// translate libs
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader'
import { HttpClient, HttpClientModule } from '@angular/common/http';

export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/lang/', '.json');
}

// initialize ng module
@NgModule({
    declarations: [
        SafePipe,
        AppComponent,
        PageContactComponent,
        PortalSeasonLoadingDefaultComponent,
        PortalPostDetailComponent,
        PortalPostListComponent,
        PageNewsComponent,
        LayoutSeasonComponent,
        PortalSeasonLoadingSeasonComponent,
        PageMypageComponent,
        PageMainComponent,
        LayoutEmptyComponent,
        PageAccessComponent,
        ComponentNavigationComponent,
        PortalSeasonPaginationComponent,
        PageCareerComponent,
        PageDashboardComponent,
        PageResearchComponent,
        ComponentChatbotComponent,
        PagePostsItemComponent,
        PortalSeasonTreeComponent,
        PortalSeasonFormDropdownComponent,
        PageAboutComponent,
        ComponentFooterComponent,
        PagePostsComponent,
        PageSolutionsComponent,
        PageMembersComponent,
        LayoutSidebarComponent,
        ComponentNavSidebarComponent,
        ComponentTypingComponent,
        PortalSeasonModalComponent,
        PageNewsItemComponent,
        PageAdminComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        FormsModule,
        NgbModule,
        SortablejsModule,
        KeyboardShortcutsModule.forRoot(),
        NuMonacoEditorModule.forRoot({ baseUrl: `lib` }),
        HttpClientModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            },
            defaultLanguage: 'en'
        }),
        
    ],
    providers: [
        {
            provide: COMPOSITION_BUFFER_MODE,
            useValue: false
        }
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }